import React, {FC, PropsWithChildren} from 'react';

import {getHasPushV2} from '../../../../../libs/shared/core/src/services/push/common/pushSelectors';
import {useCommonAppSelector} from '../../../../../libs/shared/core/src/store/useCommonAppSelector';
import {PushContextProvider} from '../../../../../libs/shared/ui/src/push/pushContextProvider';
import {useAppDispatch} from '../../../../helpers/appReduxHelpers';
import {PushContainer} from '../../pushContainer';

interface DesktopPushContextProviderProps {
  onRawBoot: (rawBoot: unknown) => void;
}

export const DesktopPushContextProvider: FC<PropsWithChildren<DesktopPushContextProviderProps>> = ({
  onRawBoot,
  children,
}) => {
  const isPushV2Enabled = useCommonAppSelector(getHasPushV2);
  const dispatch = useAppDispatch();
  if (isPushV2Enabled) {
    return <PushContextProvider>{children}</PushContextProvider>;
  }

  return (
    <PushContainer dispatch={dispatch} onRawBoot={onRawBoot}>
      {children}
    </PushContainer>
  );
};
